// src/config/pass2ji.ts
//
// 2次直前パス（¥980・2026年10月26日まで）の**唯一の情報源**。
// 司令塔承認 2026-10-12（案 A′）。
//
// なぜ1か所にまとめるか:
//   値段と期限は「購入ページ」「特商法の表記」「Stripe の決済画面」「導線ガード」の
//   4か所に出る。どれか1つだけ直すと**嘘になる**（直前パックで実際に起きた）。
//   画面側の3つはここを読む。Stripe 側（商品名・説明文・cancel_at）と
//   サーバ側（functions/handlers/stripeHandler.ts の PASS_ENDS_AT）は
//   同じ値を**別に**持っているので、ガードが毎日突き合わせる。
//
// 仕組み: 月額の購読として売り、作られた直後にサーバが cancel_at=10/26 を立てる。
//   期日に Stripe が customer.subscription.deleted を出し、既存の解約処理が regular に戻す。
//   請求は1回だけ（次の請求日より前に終わる）。買い切りにしない理由は stripeHandler.ts に書いた。

/** 利用できる最後の瞬間（JST）。サーバの PASS_ENDS_AT = 1793026799 と同じ値。 */
export const PASS_ENDS_AT = new Date('2026-10-26T23:59:59+09:00');

/** 販売を止める時刻（JST）。サーバの PASS_SALE_ENDS_AT = 1792940399 と同じ値。 */
export const PASS_SALE_ENDS_AT = new Date('2026-10-25T23:59:59+09:00');

export const PASS_2JI = {
  /** 画面の見出し */
  name: '2次直前パス',
  /** 税込・この金額以外は請求しない */
  amountYen: 980,
  amountLabel: '¥980',
  endsAt: PASS_ENDS_AT,
  /** 画面に出す期限の表記。Stripe の商品名・説明文と同じ日付 */
  endsAtLabel: '2026年10月26日',
  saleEndsAt: PASS_SALE_ENDS_AT,
  /** 購入ページ。appId 無しの /pass からも来られる（Router と firebase.json の rewrite） */
  path: '/chusho-app/pass',
  /** Stripe の価格（live / test）。サーバの SELLABLE_PRICE_IDS にも同じものが入っている */
  priceIdLive: 'price_1UPfOkJm6nYxRNS1hoTYZyWg',
  priceIdTest: 'price_1UPfNEJm6nYxRNS1L2H308qA',
} as const;

/** いま売ってよいか（画面側の判定。サーバも同じ日付で断る） */
export const isPassOnSale = (now: Date = new Date()): boolean =>
  now.getTime() <= PASS_SALE_ENDS_AT.getTime();

/**
 * 期限までの残り日数。**切り上げ**なので「残り1日」は当日いっぱいを指す。
 * 0以下になったら呼び出し側で出さない（「残り-1日」を見せない）。
 */
export const passDaysLeft = (now: Date = new Date()): number =>
  Math.ceil((PASS_ENDS_AT.getTime() - now.getTime()) / 86400000);
